module.exports = __webpack_public_path__ + "img/downcount.6693ed01.png";